import React, {useContext, useEffect, useState} from "react";
import {useAuth} from "../../../providers/authProvider";
import BoxLayout from "../../../layouts/BoxLayout";
import DefaultButton from "../../buttons/DefaultButton";
import {ApiContext} from "../../contexts/ApiContext";
import {useNavigate} from "react-router-dom";
import H2Header from "../../headers/h2";
import DefaultLayoutWithoutSideBar from "../../../layouts/DefaultLayoutWithoutSideBar";
import H1Header from "../../headers/h1";
import TextInput from "../../input/TextInput";
import NumberInput from "../../input/NumberInput";
import {ValidationContext} from "../../contexts/ValidationContext";
import {SmallTable} from "../../tables/SmallTable";
import NewChildModal from "../../modals/NewChildModal";
import EditChildModal from "../../modals/EditChildModal";
import {MdEdit, MdLocationOn, MdCalendarToday, MdHome, MdBusiness, MdEuro} from "react-icons/md";
import {FaGift, FaChild} from "react-icons/fa";
import PresentSelectionModal from "../../modals/PresentSelectionModal";


function VisitorOverviewPage() {

    const {Url} = useContext(ApiContext)
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)
    const {token} = useAuth();
    const [loading, setLoading] = useState(false)
    const [loadingVisitInfo, setLoadingVisitInfo] = useState(false)
    const [dataAvailableProfile, setDataAvailableProfile] = useState(false)
    const [dataAvailableVisitorInfo, setDataAvailableVisitor] = useState(false)
    const [openAddChildModal, setOpenAddChildModal] = useState(false);
    const [openEditChildModal, setOpenEditChildModal] = useState(false);
    const [openPresentSelectionModal, setOpenPresentSelectionModal] = useState(false);
    const [rowData, setRowData] = useState<any>(null)
    const [rowDataPresent, setRowDataPresent] = useState<any>(null)
    const [visitorData, setVisitorData] = useState<any[] | null>(null)
    const [homeVisits, setHomeVisits] = useState<any[]>([])
    const [loadingHomeVisits, setLoadingHomeVisits] = useState(false)
    const [dataAvailableHomeVisits, setDataAvailableHomeVisits] = useState(false)
    const [payments, setPayments] = useState<any[]>([])
    const [creatingPaymentFor, setCreatingPaymentFor] = useState<any>(null)
    const [paymentMessage, setPaymentMessage] = useState('')
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [adultAmount, setAdultAmount] = useState('')
    const [adultNames, setAdultNames] = useState('')
    const [message, setMessage] = useState('')


    const getColumnsChildren = () => [
        {
            Header: "Voornaam",
            accessor: "FirstName",
        },
        {
            Header: "Achternaam",
            accessor: "LastName",
        },
        {
            Header: "Leeftijd",
            accessor: "Age",
        },
        {
            id: "edit-button",
            Cell: <MdEdit/>
        }

    ];
    const getColumnsChildrenLocked = () => [
        {
            Header: "Voornaam",
            accessor: "FirstName",
        },
        {
            Header: "Achternaam",
            accessor: "LastName",
        },
        {
            Header: "Leeftijd",
            accessor: "Age",
        },
    ];
    const getColumnsPresents = () => [
        {
            Header: "Voornaam",
            accessor: "FirstName",
        },
        {
            Header: "Cadeau",
            accessor: "PresentName",
        },
        {
            id: "edit-button",
            Cell: <MdEdit/>
        }

    ];
    const getColumnsPresentsLocked = () => [
        {
            Header: "Voornaam",
            accessor: "FirstName",
        },
        {
            Header: "Cadeau",
            accessor: "PresentName",
        },

    ];

    function handleRowData(rowDataInput: any) {
        setRowData(rowDataInput)
        if (rowDataInput) {
            setOpenEditChildModal(true)
        }
    }

    function handleRowDataPresents(rowDataInput: any) {
        setRowDataPresent(rowDataInput)
        if (rowDataInput) {
            setOpenPresentSelectionModal(true)
        }
    }

    function saveProfile() {
        setMessage("Bezig met opslaan...")
        fetch(Url + 'user/profile', {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                FirstName: firstName,
                LastName: lastName,
                AdultAmount: Number(adultAmount),
                AdultNames: adultNames
            }),
        }).then((res) => {
            if (res.status === 200) {
                //Saving successfully.
                setLoading(false)
                setMessage("Het opslaan is gelukt")
            } else {
                //Saving failed
                setMessage("Het opslaan is mislukt, neem contact op.")
            }
        })
    }

    useEffect(() => {
        if (token) {
            setLoading(true)
            fetch(Url + 'user/profile', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) => {
                    if (res.status === 200) {
                        setDataAvailableProfile(true)
                        return res.json()
                    } else {
                        setDataAvailableProfile(false)
                        return [{
                            "message": "Geen Data beschikbaar over jouw profiel"
                        }]
                    }
                })
                .then((data) => {
                    setFirstName(data.FirstName)
                    setLastName(data.LastName)
                    setAdultAmount(data.CompanyVisitorsAmount)
                    setAdultNames(data.CompanyVisitorNames)
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [token, Url]);
    useEffect(() => {
        if (token) {
            setLoadingVisitInfo(true)
            fetch(Url + 'user/company-visitor-info', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) => {
                    if (res.status === 200) {
                        setDataAvailableVisitor(true)
                        return res.json()
                    } else {
                        setDataAvailableVisitor(false)
                        return [{
                            "message": "Geen Data beschikbaar over jouw bezoeken"
                        }]
                    }
                })
                .then((data) => {
                    setVisitorData(Array.isArray(data) ? data : [])
                })
                .finally(() => {
                    setLoadingVisitInfo(false)
                })
        }
    }, [token, Url, openAddChildModal, openEditChildModal, openPresentSelectionModal]);
    useEffect(() => {
        if (token) {
            try {
                setLoadingHomeVisits(true)
                fetch(Url + 'user/home-visits', {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + token,
                    },
                })
                    .then((res) => {
                        if (res.status === 200) {
                            setDataAvailableHomeVisits(true)
                            return res.json()
                        } else {
                            setDataAvailableHomeVisits(false)
                            return [{
                                "message": "Geen huisbezoeken gevonden"
                            }]
                        }
                    })
                    .then((data) => {
                        setHomeVisits(Array.isArray(data) ? data : [])
                    })
                    .finally(() => {
                        setLoadingHomeVisits(false)
                    })
            } catch (error) {
                setDataAvailableHomeVisits(false)
            }
        }
    }, [token, Url]);

    useEffect(() => {
        if (token) {
            fetch(Url + 'user/payments', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) => {
                    if (res.status === 200) {
                        return res.json()
                    }
                    return []
                })
                .then((data) => {
                    setPayments(Array.isArray(data) ? data : [])
                })
                .catch(() => {
                    setPayments([])
                })
        }
    }, [token, Url, creatingPaymentFor]);

    function handleHomeVisitDetails(id: any) {
        navigate("/home/visit-details/" + id, {replace: false})
    }

    // Check whether a home visit has a valid e-boekhouden invoice.
    const hasValidInvoice = (homeVisit: any) => {
        const invoiceId = homeVisit?.EboekhoudenInvoiceId ?? homeVisit?.InvoiceId
        return invoiceId !== undefined && invoiceId !== null && invoiceId !== ''
    }

    // Find an existing payment for a given home visit (matched by e-boekhouden invoice id).
    const getPaymentForHomeVisit = (homeVisit: any) => {
        if (!hasValidInvoice(homeVisit)) {
            return undefined
        }
        const invoiceId = homeVisit?.EboekhoudenInvoiceId ?? homeVisit?.InvoiceId
        return payments.find((p) => String(p.InvoiceId) === String(invoiceId))
    }

    // A home visit is considered paid when the backend flagged it as paid,
    // or when a related payment has a final "paid" status.
    const isHomeVisitPaid = (homeVisit: any) => {
        if (homeVisit?.Payed === true) {
            return true
        }
        const payment = getPaymentForHomeVisit(homeVisit)
        return payment?.Status === 'paid'
    }

    // A payment is "in progress" while it is created (open) or awaiting confirmation (pending).
    const hasPaymentInProgress = (homeVisit: any) => {
        const payment = getPaymentForHomeVisit(homeVisit)
        return payment?.Status === 'open' || payment?.Status === 'pending'
    }

    // Continue an existing (open/pending) payment by redirecting to its checkout page.
    function continuePayment(homeVisit: any) {
        const payment = getPaymentForHomeVisit(homeVisit)
        if (payment && payment.CheckoutURL) {
            window.location.href = payment.CheckoutURL
        } else {
            startPayment(homeVisit)
        }
    }

    // Start a Mollie payment for a home visit and redirect the user to the checkout page.
    function startPayment(homeVisit: any) {
        setCreatingPaymentFor(homeVisit.ID)
        setPaymentMessage("Bezig met het aanmaken van de betaling...")
        fetch(Url + 'user/payments', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                invoiceId: Number(homeVisit.EboekhoudenInvoiceId ?? homeVisit.InvoiceId),
                amount: homeVisit.Amount,
                currency: homeVisit.Currency || 'EUR',
                description: homeVisit.EboekhoudenInvoiceNumber
                    ? "Factuur " + homeVisit.EboekhoudenInvoiceNumber
                    : undefined,
                redirectUrl: window.location.origin + '/payments/return',
            }),
        })
            .then((res) => {
                if (res.status === 201) {
                    return res.json()
                }
                return Promise.reject(new Error("Betaling aanmaken mislukt"))
            })
            .then((data) => {
                if (data && data.CheckoutURL) {
                    window.location.href = data.CheckoutURL
                } else {
                    setPaymentMessage("Het aanmaken van de betaling is mislukt, neem contact op.")
                }
            })
            .catch(() => {
                setPaymentMessage("Het aanmaken van de betaling is mislukt, neem contact op.")
            })
            .finally(() => {
                setCreatingPaymentFor(null)
            })
    }

    // Helper: always expose { questions: [...] } to modals for a given visit index
    const getChildQuestionsFor = (idx: number) => {
        const visit = visitorData?.[idx];
        const arr = Array.isArray(visit?.ChildQuestions)
            ? visit.ChildQuestions
            : visit?.ChildQuestions?.questions;
        return { questions: arr || [] };
    };

    // Helper: update only the ChildQuestions for a given visit index
    const setChildQuestionsFor = (idx: number, next: any) => {
        setVisitorData((prev) => {
            const arr = Array.isArray(prev) ? [...prev] : [];
            const currentVisit = arr[idx] || {};
            const nextObj = typeof next === "function" ? next(getChildQuestionsFor(idx)) : next;
            arr[idx] = {
                ...currentVisit,
                // Store as an array on the visit, modals still receive { questions: [...] }
                ChildQuestions: nextObj?.questions || [],
            };
            return arr;
        });
    };

    let profileData
    if (dataAvailableProfile) {
        profileData = (
            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                <H2Header headerText="Algemene gegevens"/>
                <div className="rounded-lg border-l-4 border-blue-800 bg-blue-50 p-4 text-sm leading-relaxed text-gray-700">
                    Welkom terug! Hier kan je je gegevens inzien en wijzigen. Let op, na de inschrijf deadline kan je alleen nog maar tekstuele wijzigingen doorvoeren tot een week voor het bezoek. Zorg dus dat al je kinderen voor die tijd ingeschreven zijn.
                    Alle informatie wijzigt direct. Je kan deze pagina verlaten zodra je klaar bent.
                </div>
                {message && <p className="mt-3 text-base leading-relaxed text-red-500">
                    {message}
                </p>}
                <TextInput
                    labelName="Jouw voornaam"
                    inputName="firstName"
                    placeholder="Voornaam"
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstName}
                    errorMessage={nameErrorMessage}
                    pattern={nameRegex}
                    type="text">
                </TextInput>
                <TextInput
                    labelName="Jouw achternaam"
                    inputName="lastName"
                    placeholder="Achternaam"
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                    errorMessage={nameErrorMessage}
                    pattern={nameRegex}
                    type="text">
                </TextInput>
                <NumberInput
                    labelName="Aantal volwassen personen die naar het feest bij jouw bedrijf komen."
                    inputName="alduts"
                    onChange={(e) => setAdultAmount(e.target.value)}
                    value={adultAmount}
                    placeholder="Aantal volwassen personen"
                    errorMessage="Minimaal 1 volwassen persoon moet zich opgeven. Gebruik alleen getallen."
                    max={9}
                    min={1}
                    step="1"
                />
                <TextInput
                    labelName="De namen van de volwassen personen die naar het feest bij jouw bedrijf komen."
                    inputName="aldutNames"
                    placeholder="Naam1, Naam2, Naam3"
                    onChange={(e) => setAdultNames(e.target.value)}
                    value={adultNames}
                    errorMessage={nameErrorMessage}
                    pattern={nameRegex}
                    type="text">
                </TextInput>
                <div className="flex justify-end">
                    <DefaultButton content="Bijwerken" onClick={saveProfile}></DefaultButton>
                </div>
            </div>
        )
    } else {
        profileData = (
            <div>Geen profiel in de database of je hebt geen rechten om deze informatie te bekijken.</div>
        )
    }

    let visitorDataView
    if (dataAvailableVisitorInfo && visitorData) {
        visitorDataView = (
            visitorData.map((companyVisit, index) =>
                <div className="mt-6 rounded-xl border border-gray-200 bg-white p-5 shadow-sm" key={index}>
                    <div className="grid grid-cols-3">
                        <div className="col-span-3">
                            <div className="flex items-center gap-3">
                                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-800">
                                    <MdBusiness className="h-6 w-6"/>
                                </div>
                                <div>
                                    <h2 className="text-2xl font-serif font-bold text-gray-900">{companyVisit.Company}</h2>
                                    {companyVisit.Locked
                                        ? <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold text-gray-600">Inschrijving gesloten</span>
                                        : <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-semibold text-green-700">Inschrijving open</span>}
                                </div>
                            </div>
                            <div className="mt-4 grid gap-2 sm:grid-cols-2">
                                <p className="flex items-center gap-1.5 text-sm text-gray-600">
                                    <MdCalendarToday className="h-4 w-4 text-gray-400"/> {companyVisit.Date}
                                </p>
                                <p className="flex items-center gap-1.5 text-sm text-gray-600">
                                    <MdLocationOn className="h-4 w-4 text-gray-400"/> {companyVisit.Address + ", " + companyVisit.Zipcode + ", " + companyVisit.City}
                                </p>
                                <p className="flex items-center gap-1.5 text-sm text-gray-600 sm:col-span-2">
                                    <MdEdit className="h-4 w-4 text-gray-400"/> Inschrijfdeadline: {companyVisit.SoftSignUpDeadline}
                                </p>
                            </div>
                            <p className="mt-6 flex items-center gap-2 text-2xl font-serif font-bold text-gray-900"><FaChild className="h-5 w-5 text-blue-800"/> Ingeschreven Kinderen</p>
                            {companyVisit.Locked &&
                                <p>De inschrijving is gesloten het is niet meer mogelijk om gegevens te wijzigen. Wil je
                                    toch nog iets doorgeven, neem dan contact op met je contactpersoon.</p>}
                            {!companyVisit.Locked &&
                                <p>Klik op de naam van een kind om de gegevens te wijzigen. Je kan kinderen toevoegen
                                    tot en
                                    met {companyVisit.SoftSignUpDeadline}.</p>}

                            {!companyVisit.Locked &&
                                <SmallTable tableData={companyVisit.Children} setRowdata={setRowData}
                                            onRowClick={handleRowData}
                                            getColumns={getColumnsChildren()}></SmallTable>}
                            {companyVisit.Locked &&
                                <SmallTable tableData={companyVisit.Children} setRowdata={setRowData}
                                            getColumns={getColumnsChildrenLocked()}
                                            onRowClick={() => alert("Wijzigen niet mogelijk")}></SmallTable>}
                            <div className="flex justify-end">
                                {!companyVisit.Locked && <DefaultButton content="Voeg kind toe"
                                                                        onClick={() => setOpenAddChildModal(true)}
                                                                        disabled={companyVisit.ChildrenSignupLocked}
                                />}
                                <NewChildModal
                                    openModal={openAddChildModal}
                                    setOpenModal={setOpenAddChildModal}
                                    welcomePage={false}
                                    signUpCode={companyVisit.SignUpCode}
                                    minChildAge={companyVisit.MinChildAge}
                                    maxChildAge={companyVisit.MaxChildAge}
                                    childQuestions={getChildQuestionsFor(index)}
                                    setChildQuestions={(updater: any) => setChildQuestionsFor(index, updater)}
                                />

                                <EditChildModal
                                    openModal={openEditChildModal}
                                    setOpenModal={setOpenEditChildModal}
                                    welcomePage={false}
                                    signUpCode={companyVisit.SignUpCode}
                                    minChildAge={companyVisit.MinChildAge}
                                    maxChildAge={companyVisit.MaxChildAge}
                                    rowData={rowData}
                                    childQuestions={getChildQuestionsFor(index)}
                                    setChildQuestions={(updater: any) => setChildQuestionsFor(index, updater)}
                                />

                            </div>
                            {companyVisit.PresentServiceActive && <p className="mt-6 flex items-center gap-2 text-2xl font-serif font-bold text-gray-900"><FaGift className="h-5 w-5 text-blue-800"/> Cadeauselectie</p>}
                            {companyVisit.PresentServiceActive && !companyVisit.Locked &&
                                <p>Klik op de naam van een kind om het cadeau te wijzigen. Je kan cadeaus wijzigen tot
                                    en
                                    met {companyVisit.SoftSignUpDeadline}.</p>}
                            {companyVisit.PresentServiceActive && companyVisit.Locked &&
                                <p>De inschrijving is gesloten het is niet meer mogelijk om de cadeautjes te wijzigen.
                                    Wil je toch nog iets doorgeven, neem dan contact op met je contactpersoon..</p>}
                            {companyVisit.PresentServiceActive && !companyVisit.Locked &&
                                <SmallTable tableData={companyVisit.PresentInfo} setRowdata={setRowData}
                                            onRowClick={handleRowDataPresents}
                                            getColumns={getColumnsPresents()}></SmallTable>}
                            {companyVisit.PresentServiceActive && companyVisit.Locked &&
                                <SmallTable tableData={companyVisit.PresentInfo} setRowdata={setRowData}
                                            getColumns={getColumnsPresentsLocked()}
                                            onRowClick={() => alert("Wijzigen niet mogelijk")}></SmallTable>}
                            {companyVisit.PresentServiceActive &&
                                <PresentSelectionModal openModal={openPresentSelectionModal}
                                                       setOpenModal={setOpenPresentSelectionModal}
                                                       presents={companyVisit.Presents}
                                                       rowData={rowDataPresent} welcomePage={false}/>}

                        </div>
                    </div>
                </div>
            )
        )
    } else {
        visitorDataView = (
            <div className="flex flex-col items-center rounded-xl border border-dashed border-gray-300 bg-gray-50 p-8 text-center">
                <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-blue-800">
                    <MdBusiness className="h-7 w-7"/>
                </div>
                <p className="max-w-md text-gray-600">
                    Er staan op dit moment geen kinderen ingeschreven bij een bedrijfsbezoek. Inschrijven voor een
                    bedrijfsbezoek? Klik dan op de knop hieronder.
                </p>
                <div className="mt-4">
                    <DefaultButton content="Inschrijven"
                                   onClick={() => navigate("/company/welcome/", {replace: false})}></DefaultButton>
                </div>
            </div>
        )

    }

    let homeVisitDataView
    if (dataAvailableHomeVisits && Array.isArray(homeVisits) && homeVisits.length > 0) {
        homeVisitDataView = (
            <div className="grid grid-cols-1 gap-4">
                {homeVisits.map((homeVisit) =>
                    <div
                        className="group cursor-pointer rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:border-blue-300 hover:shadow-md"
                        onClick={() => handleHomeVisitDetails(homeVisit.ID)} key={homeVisit.ID}>
                        <div className="flex items-start justify-between gap-4">
                            <div className="flex items-start gap-3">
                                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-800">
                                    <MdHome className="h-6 w-6"/>
                                </div>
                                <div>
                                    <h3 className="text-xl font-serif font-bold text-gray-900 transition-colors group-hover:text-blue-800">
                                        {homeVisit.HomeVisitCategoryName}
                                    </h3>
                                    <p className="mt-1 flex items-center gap-1.5 text-sm text-gray-600">
                                        <MdCalendarToday className="h-4 w-4 text-gray-400"/>
                                        {homeVisit.Date}
                                    </p>
                                    <p className="mt-1 flex items-center gap-1.5 text-sm text-gray-600">
                                        <MdLocationOn className="h-4 w-4 text-gray-400"/>
                                        {homeVisit.Address + ", " + homeVisit.ZipCode + ", " + homeVisit.City}
                                    </p>
                                </div>
                            </div>
                            <div className="shrink-0">
                                {isHomeVisitPaid(homeVisit) && (
                                    <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
                                        <MdEuro className="h-3.5 w-3.5"/> Betaald
                                    </span>
                                )}
                                {!isHomeVisitPaid(homeVisit) && hasPaymentInProgress(homeVisit) && (
                                    <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
                                        In behandeling
                                    </span>
                                )}
                                {!isHomeVisitPaid(homeVisit) && !hasPaymentInProgress(homeVisit) && hasValidInvoice(homeVisit) && (
                                    <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-3 py-1 text-xs font-semibold text-red-700">
                                        Openstaand
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="mt-4 flex flex-wrap gap-3">
                            <DefaultButton content="Grote boek invullen" onClick={undefined}></DefaultButton>
                            {hasValidInvoice(homeVisit) && !isHomeVisitPaid(homeVisit) && (
                                <DefaultButton
                                    content={creatingPaymentFor === homeVisit.ID
                                        ? "Bezig..."
                                        : (hasPaymentInProgress(homeVisit) ? "Betaling afronden" : "Betalen")}
                                    disabled={creatingPaymentFor === homeVisit.ID}
                                    onClick={(e: any) => {
                                        e.stopPropagation();
                                        if (hasPaymentInProgress(homeVisit)) {
                                            continuePayment(homeVisit);
                                        } else {
                                            startPayment(homeVisit);
                                        }
                                    }}></DefaultButton>
                            )}
                        </div>
                        {paymentMessage &&
                            <p className="mt-3 text-base leading-relaxed text-red-500">{paymentMessage}</p>}
                    </div>
                )}
            </div>
        )
    } else {
        homeVisitDataView = (
            <div className="flex flex-col items-center rounded-xl border border-dashed border-gray-300 bg-gray-50 p-8 text-center">
                <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-blue-800">
                    <MdHome className="h-7 w-7"/>
                </div>
                <p className="max-w-md text-gray-600">
                    Sint en Piet kunnen ook bij jou thuis komen. Wil je een huisbezoek aanvragen, klik dan op de knop
                    hieronder.
                </p>
                <div className="mt-4">
                    <DefaultButton content="Aanvragen"
                                   onClick={() => window.open(window.location.origin + '/contact', '_blank')}></DefaultButton>
                </div>
            </div>
        )
    }

    const hasCompanyVisits = dataAvailableVisitorInfo && Array.isArray(visitorData) && visitorData.length > 0
    const hasHomeVisits = dataAvailableHomeVisits && Array.isArray(homeVisits) && homeVisits.length > 0
    const showBothHeaders = hasCompanyVisits && hasHomeVisits

    return (
        <DefaultLayoutWithoutSideBar>
            <div className="flex flex-col py-4 sm:py-0">
                <BoxLayout>
                    {loading ? (
                        <div>Loading...</div>
                    ) : (
                        <div className="mb-8">
                            <H1Header headerText="Overzicht van jouw bezoeken"/>
                        </div>
                    )}
                    {(loadingVisitInfo || loadingHomeVisits) ? (
                        <div>Loading...</div>
                    ) : (
                        <>
                            {(showBothHeaders || hasHomeVisits || !hasCompanyVisits) && (
                                <>
                                    <div className="my-4">
                                        {showBothHeaders && <H2Header headerText="Jouw huisbezoeken"/>}
                                        {homeVisitDataView}
                                    </div>
                                </>
                            )}
                            {(showBothHeaders || hasCompanyVisits) && (
                                <>
                                    <hr className="my-8"/>
                                    <div className="mb-8">
                                        {showBothHeaders && <H2Header headerText="Jouw bedrijfsbezoeken"/>}
                                        {profileData}
                                        {visitorDataView}
                                    </div>
                                </>
                            )}

                        </>
                    )}
                </BoxLayout>
            </div>
        </DefaultLayoutWithoutSideBar>
    )
}

export default VisitorOverviewPage